/**
 * ОБВОДКИ ЯЧЕЕК на поле: доступные для строительства, хода, маневра, цели и сама
 * выбранная ячейка. Светящееся кольцо по контуру ячейки в гамме медальонов: темная
 * подложка держит линию на светлых подложках поля, поверх золотой ореол с искрами
 * в вершинах и светлая сердцевина. По сетке от выбранного отряда расходится волна
 * света; у выбранной ячейки кольцо толще, и по нему бегут огоньки.
 *
 * Рисует scenes/FieldCellOutlines, текстуры считает код
 * (utils/effects/cellOutlineTextures).
 */

export const CELL_OUTLINE_TEXTURE_KEYS = {
  CORE: 'cell_outline_core',
  CORE_THICK: 'cell_outline_core_thick',
  CORE_DASHED: 'cell_outline_core_dashed',
  GLOW: 'cell_outline_glow',
};

export const CELL_OUTLINE_PALETTES = {
  // Обычная доступная ячейка
  DEFAULT: {core: 0xfff6d6, halo: 0xffb81f, mote: 0xfffbe8},
  // Ячейка доступна, но сейчас нельзя: например, строить мешает противник
  BLOCKED: {core: 0xffa494, halo: 0xe2201c, mote: 0xffe0d8},
  // Выбранная ячейка: те же цвета, что у доступной, отличается толщиной и огоньками.
  // Насыщенно-желтая сливалась с границей желтого игрока. Огоньки цвета ореола: белые на
  // светлой сердцевине не видны
  SELECTED: {core: 0xfff6d6, halo: 0xffb81f, mote: 0xffb81f},
};

export const CELL_OUTLINE = {
  shadowTint: 0x140a03,
  shadowAlpha: 0.5,
  // Волна по сетке: период и расстояние между гребнями на поле
  wave: {periodMs: 2000, lengthPx: 440, minAlpha: 0.4, maxAlpha: 1},
  selected: {
    // Выше соседних обводок: на общей стороне видно именно выбранную ячейку
    depthLift: 0.05,
    // Ореол выбранной ячейки дышит сам по себе, без волны
    pulseMs: 1100,
    minAlpha: 0.65,
    maxAlpha: 1,
    outerScale: 1.09,
    motes: {count: 3, periodMs: 2400, sizeFactor: 0.42},
  },
};
